var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86667 10.6667H1.33333C0.6 10.6667 0 10.0667 0 9.33333V1.33333C0 0.6 0.6 0 1.33333 0H5.33333L6.66667 1.33333H12C12.7333 1.33333 13.3333 1.93333 13.3333 2.66667V7.06667C12.9333 6.8 12.4667 6.53333 12 6.33333V2.66667H1.33333V9.33333H4.86667C4.86667 9.4 4.8 9.46667 4.8 9.53333L4.53333 10L4.73333 10.4667C4.8 10.5333 4.8 10.6 4.86667 10.6667ZM14 10C13.4 11.5333 11.8 12.6667 10 12.6667C8.2 12.6667 6.6 11.5333 6 10C6.6 8.46667 8.2 7.33333 10 7.33333C11.8 7.33333 13.4 8.46667 14 10ZM11.6667 10C11.6667 9.06667 10.9333 8.33333 10 8.33333C9.06667 8.33333 8.33333 9.06667 8.33333 10C8.33333 10.9333 9.06667 11.6667 10 11.6667C10.9333 11.6667 11.6667 10.9333 11.6667 10ZM10 9.33333C9.6 9.33333 9.33333 9.6 9.33333 10C9.33333 10.4 9.6 10.6667 10 10.6667C10.4 10.6667 10.6667 10.4 10.6667 10C10.6667 9.6 10.4 9.33333 10 9.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.6b1b6b79.svg";
export { ForwardRef as ReactComponent };